<template>
  <RevChip
    :aria-label="i18n(translations.title)"
    class="bg-action-default-low !border-action-default-low border-1 border-solid"
    data-test="country-switch-menu-button"
    :label="MarketCountryCode[countryCode]"
    size="medium"
    :start-icon="CurrentMarketCountryFlag"
    @click="handleClick"
  />
</template>

<script setup lang="ts">
import {
  type CountryCodeValue,
  MarketCountryCode,
} from '@backmarket/http-api/src/api-models/MarketCountryCode'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevChip } from '@ds/components/Chip'

import translations from './CountrySwitch.translations'
import CurrentMarketCountryFlag from './CurrentMarketCountryFlag.vue'

const { countryCode, trackingSpot } = defineProps<{
  countryCode: CountryCodeValue
  trackingSpot: 'header' | 'nav'
}>()

const emit = defineEmits(['click'])

const i18n = useI18n()
const { trackCountrySwitchClick } = useTracking()

const trackButtonClick = () => {
  trackCountrySwitchClick({
    name: 'country_switch',
    zone: trackingSpot,
  })
}

const handleClick = () => {
  trackButtonClick()
  emit('click')
}
</script>
